import { ORDER_STORAGE_CLOSET } from '../../namespace/storage/order-storage-closet'
import { API } from '../../../../api/api'

export const orderStorageCloset = {
  state: {
    data: []
  },
  mutations: {
    [ORDER_STORAGE_CLOSET.MUTATIONS.SET_DATA](state, data) {
      state.data = data
    }
  },
  actions: {
    async [ORDER_STORAGE_CLOSET.ACTIONS.INIT_DATA]({ commit }) {
      try {
        const response = (await API.getStorageItems()).data
        commit(ORDER_STORAGE_CLOSET.MUTATIONS.SET_DATA, response)
        return response
      } catch (e) {
        throw new Error('order storage items request error')
      }
    }
  },
  getters: {
    [ORDER_STORAGE_CLOSET.GETTERS.DATA](state) {
      return state.data
    }
  }
}
